import { ApolloProvider } from '@apollo/client';
import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App/App';
import ErrorPage from './components/error-page/errorPage';
import { apolloClient } from './services/graphql-client';
import * as honeybadger from './services/honeybadger';
import * as plausible from './services/plausible';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles/index.css';

honeybadger.bootstrap();
plausible.bootstrap();

const container = document.getElementById('app');
if (!container) {
  throw new Error('Root element #app not found');
}

createRoot(container).render(
  <HoneybadgerErrorBoundary honeybadger={Honeybadger} ErrorComponent={ErrorPage}>
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ApolloProvider>
  </HoneybadgerErrorBoundary>
);

// CRA Service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
